import request, { gql } from "graphql-request";
import { useState, useEffect } from "react";
import { createContext } from "react";
import BASEURL from "../../pages/Utils/Baseurl";
import { allLeadprospect, getLeadprospectDetailByUser } from "../../lib/graphQL/graphQuery";
import { useContext } from "react";
import { useAuth } from "../AuthContext/AuthContextProvider";


const getLeadprospectDetailByMaster = gql`
query getLeadprospectDetailByMaster($id: String!) {
    getLeadprospectDetailByMaster(id: $id) {
      id
      prsid
      companyName
      leadSource
      addressLine1
      
      user {
        username
      }
      createdAt
    }
  }
`;
export const MyLeadandProspect = createContext();

export default function LeadAndProspectContext({ children }) {
  const [leadData, setLeadData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const { currentUser, authenticated } = useAuth();
  const isUser = currentUser?.role;
  useEffect(() => {
    if (authenticated) {



      fetchLeaddata();
    }

  }, []);
  const fetchLeaddata = async () => {
    // setIsLoading(true);
    // try {
    //   const res = await request(BASEURL, getLeadprospectDetailByUser, {
    //     id: currentUser?.id,
    //   });

    //   setLeadData(res.getLeadprospectDetailByUser);
    // } catch (err) {
    // } finally {
    //   setIsLoading(false);
    // }
    if (isUser?.toLowerCase() == "employee") {
      fetchEmployeeData()

    }
    else if (isUser.toLowerCase() == "manager") {
      fetchMangerData()
    }
    else if (isUser.toLowerCase() == "superuser") {
      fetchallData()
    } else {
      setLeadData([])
    }
  };
  const fetchallData = () => {
    request(BASEURL, allLeadprospect, { id: currentUser?.id })
      .then((res) => setLeadData(res?.allLeadprospect))
  }
  const fetchEmployeeData = () => {
    request(BASEURL, getLeadprospectDetailByUser, { id: currentUser?.id })
      .then((res) => setLeadData(res?.getLeadprospectDetailByUser))
  }
  const fetchMangerData = () => {
    request(BASEURL, getLeadprospectDetailByMaster, { id: currentUser?.id })
      .then((res) => setLeadData(res?.getLeadprospectDetailByMaster))
  }
  return (
    <MyLeadandProspect.Provider
      value={{
        leadData,
        setLeadData,
        isLoading,
        setIsLoading,
        status,
        setStatus,
        fetchLeaddata
      }}
    >
      {children}
    </MyLeadandProspect.Provider>
  );
}

export const useLeadAndProscpect = () => {
  return useContext(MyLeadandProspect);
};
